import axios from "axios";
import { API_ENDPOINT } from "./resources";

const normalizeSortOrder = (order) => {
  const normalized = String(order || "").toLowerCase().trim();
  if (!normalized) return "";
  if (normalized === "asc" || normalized === "asc") return "asc";
  if (normalized === "desc" || normalized === "desc") return "desc";
  return order;
};

export const getAllVendorInvoices = async (
  org_token,
  authToken = "",
  options = {}
) => {
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : {};

  const sortKey = options?.sortKey ?? options?.sort_key ?? "";
  const sortOrderRaw = options?.sortOrder ?? options?.sort_order ?? "";
  const sortOrder = normalizeSortOrder(sortOrderRaw);

  const payload = {
    org_token,
    ...(options?.page ? { page: options.page } : {}),
    ...(options?.pageSize ? { page_size: options.pageSize } : {}),
    ...(sortKey ? { sort_key: sortKey } : {}),
    ...(sortOrder ? { sort_order: sortOrder } : {}),
  };

  const response = await axios.post(
    API_ENDPOINT.get_all_vendor_invoices,
    payload,
    { headers }
  );

  return response?.data || {};
};

export const getVendorInvoiceDetails = async (
  token,
  authToken = "",
  options = {}
) => {
  const headers = authToken
    ? { Authorization: `Bearer ${authToken}` }
    : {};

  const payload = {
    token,
    page: Number(options?.page || 1),
  };

  const response = await axios.post(
    API_ENDPOINT.get_vendor_invoice,
    payload,
    { headers }
  );

  return response?.data || {};
};
